import { sendNblyBrandEmailWrapper } from '../apiCaching/POST-Requests/apiSendNblyBrandEmail';

export class NblyBrandContactUs {
 
    static instance: NblyBrandContactUs | null = null;
    
    private constructor() {}
    
    static getInstance(): NblyBrandContactUs {
        if (!NblyBrandContactUs.instance) {
            NblyBrandContactUs.instance = new NblyBrandContactUs();
        }
        return NblyBrandContactUs.instance;
    }

    constructPayload(existingPayload: any): any {
        if(!existingPayload.email)
            return;
        const selfPayload = {
            "sender": process.env.NBLY_SENDER_EMAIL ?? "",
            "templateId": process.env.TEMPLATEID_SENDGRID_SELF ?? "",
            "receiver": existingPayload.email,
            "EmailObject": {
                "firstName": existingPayload.firstName,
                "lastName": existingPayload.lastName
            }
        }
        const switchBoardPayload = {
            "sender":  process.env.NBLY_SENDER_EMAIL ?? "",
            "templateId": process.env.TEMPLATEID_SENDGRID_SWITCHBOARD ?? "",
            "receiver": "neighborly.switchboard@nbly.com",
            "EmailObject": {
                "firstName": existingPayload.firstName,
                "lastName": existingPayload.lastName,
                "phoneNumber": existingPayload.phone,
                "postalCode": existingPayload.zipCode,
                "emailAddress": existingPayload.email,
                "message": existingPayload.comments
            }
        }
        return [selfPayload, switchBoardPayload];
    }

    async callParallelEmails(existingPayload: any): Promise<void> {
        const payloads = this.constructPayload(existingPayload);
        
        if (!payloads) {
            console.error('No payloads generated from constructPayload');
            return;
        }

        const [selfPayload, switchBoardPayload] = payloads;

        const results = await Promise.allSettled([
            sendNblyBrandEmailWrapper(selfPayload),
            sendNblyBrandEmailWrapper(switchBoardPayload)
        ]);

        results.forEach((result, index) => {
            const emailType = index === 0 ? 'self' : 'switchboard';
            if (result.status === 'rejected') {
                console.error(`Failed to send ${emailType} email:`, result.reason);
            }
        });

        const allFailed = results.every(result => result.status === 'rejected');
        if (allFailed) {
            throw new Error('All email sends failed');
        }
    }
}